<div class="attachment">
  <mat-icon class="remove" (click)="removeEvent.emit()">delete</mat-icon>
  <app-blob-viewer *ngIf="thumbnailBlob" [blob]="thumbnailBlob" [ngClass]="{ 'show-img': !showIcon }" (loadError)="onLoadError()"></app-blob-viewer
  ><span *ngIf="showIcon" class="mdi mdi-{{ file.icon }} file-{{ file.icon }}"></span>
  <span class="desc" *ngIf="showIcon">{{ file.name }}</span>
</div>
